<template>
  <div>
    <p style="margin-left: 10px; margin-top: 0.5em;">
      <b>- 기본 정보:</b>
    </p>
    <p style="margin-left: 20px;">
      <b>- 사용자 이름:</b>
      {{ author.username }}
    </p>
    <p style="margin-left: 20px;">
      <b>- 사용자 아이디:</b>
      {{ author.identity }}
    </p>
    <p style="margin-left: 20px;">
      <b>- 사용자 고유넘버:</b>
      {{ author.idx }}
    </p>
    <p style="margin-left: 20px;">
      <b>- 등록 시간:</b>
      {{ $moment(uploadAt).format('llll') }}
    </p>
    <a-card style="margin-top: 1em;">
      <VueMarkdown>{{ contents }}</VueMarkdown>
    </a-card>
    <a-divider orientation="left">답변</a-divider>
    <a-textarea v-model="answer" placeholder="답변해주세요." :autosize="{ minRows: 6, maxRows: 6 }" />
    <a-button
      style="float: right; margin: 0.5em;"
      @click="onAnswer"
      type="primary"
      icon="check"
    >답변하기</a-button>
    <a-divider orientation="left">댓글</a-divider>
    <ul style="margin: 3px;" v-if="comments.length > 0">
      <BroadcastAdminComment
        v-for="(comment, index) in comments"
        :key="index"
        :idx="idx"
        :editingIdx="editingIdx"
        :commentIdx="comment.idx"
        :uploadAt="$moment(comment.uploadAt)"
        :author="comment.author"
        :contents="comment.contents"
        :refreshComments="onComment"
        :setEditingMode="setEditingMode"
        :isMine="comment.author.idx === $store.state.admin.idx"
      />
    </ul>
    <a-comment>
      <div slot="content">
        <a-form-item>
          <a-textarea :rows="4" v-model="message"></a-textarea>
        </a-form-item>
        <a-form-item>
          <a-button @click="onWrite" type="primary">댓글 {{ editingIdx === '' ? '달기' : '수정' }}</a-button>
        </a-form-item>
      </div>
    </a-comment>
  </div>
</template>
<script>
import config from "../../config";
import OPCODE from "../../libs/OPCODE";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import Axios from "axios";
import VueMarkdown from "vue-markdown";
import BroadcastAdminComment from "./BroadcastAdminComment";

export default {
  name: "BroadcastAdminCard",
  props: ["idx", "title", "contents", "uploadAt", "author", "answer"],
  components: { VueMarkdown, BroadcastAdminComment },
  data() {
    this.onComment();
    return {
      message: "",
      editingIdx: "",
      comments: []
    };
  },
  methods: {
    async onComment() {
      try {
        const { idx } = this;
        const {
          data
        } = await Axios.get(
          `${config.hostname}/v1/admin/question/comment/${idx}`,
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              this.comments = data.comments;
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "오류로 인해 댓글을 가져올 수 없습니다."
              });
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "댓글을 가져올 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
    },
    async onWrite() {
      if (this.message.length < 3) {
        return config.alert.mixin({
          type: "warning",
          title: "최소 3자리 이상 입력하여 주세요."
        });
      }

      const { data } = await Axios.post(
        `${config.hostname}/v1/admin/question/comment/${this.idx}/${this.editingIdx}`,
        { contents: this.message },
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            await this.onComment();
            this.editingIdx = "";
            this.message = "";
            break;
        }
      }
    },
    async onAnswer() {
      try {
        const { idx, answer } = this;
        const { data } = await Axios.post(
          `${config.hostname}/v1/admin/question/${idx}`,
          { answer },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              config.alert.mixin({
                type: "success",
                title: `성공적으로 답변되었습니다.`
              });
              this.$emit("refresh");
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: `알 수 없는 오류로 답변할 수 없습니다.`
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "오류로 인해 답변할 수 없습니다."
        });
      }
    },
    setEditingMode(idx, contents) {
      if (this.editingIdx !== idx) {
        this.editingIdx = idx;
        this.message = contents;
      } else {
        this.editingIdx = "";
        this.message = "";
      }
    }
  }
};
</script>
